var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "planning-wrapper scrollable" }, [
    _c("div", { staticClass: "limit" }, [
      _c("div", { staticClass: "table-subtitle" }, [
        _c("h3", [_vm._v(_vm._s(_vm.$t("dash.optimalTimes.title")))])
      ]),
      _c("p", { staticClass: "subtitle" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("dash.optimalTimes.subtitle")) +
            " " +
            _vm._s(_vm.formatDate(_vm.optimalTimes.date.request_at)) +
            " : \n        " +
            _vm._s(_vm.$t("dash.reporting.from")) +
            " " +
            _vm._s(_vm.formatDate(_vm.optimalTimes.date.since_at, false)) +
            " \n        " +
            _vm._s(_vm.$t("dash.reporting.to")) +
            " " +
            _vm._s(_vm.formatDate(_vm.optimalTimes.date.until_at, false)) +
            " \n      "
        )
      ]),
      _c(
        "div",
        { staticClass: "limit-wrapper" },
        [
          _c(
            "vs-radio",
            {
              class: { active: _vm.filter === "impressions" },
              attrs: { name: "content", "vs-value": "impressions" },
              model: {
                value: _vm.filter,
                callback: function($$v) {
                  _vm.filter = $$v
                },
                expression: "filter"
              }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("dash.reporting.impression")) +
                  "\n        "
              )
            ]
          ),
          _vm.network !== "instagram"
            ? _c(
                "vs-radio",
                {
                  class: { active: _vm.filter === "clics" },
                  attrs: { name: "content", "vs-value": "clics" },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("dash.reporting.clic")) +
                      "\n        "
                  )
                ]
              )
            : _vm._e(),
          _c(
            "vs-radio",
            {
              class: { active: _vm.filter === "engagement" },
              attrs: { name: "content", "vs-value": "engagement" },
              model: {
                value: _vm.filter,
                callback: function($$v) {
                  _vm.filter = $$v
                },
                expression: "filter"
              }
            },
            [
              _vm._v(
                "\n              " +
                  _vm._s(_vm.$t("dash.reporting.engagemment")) +
                  "\n        "
              )
            ]
          ),
          _c(
            "Tooltip",
            {
              staticClass: "tooltipRefresh",
              attrs: { text: _vm.$t("dash.reporting.period_thirty_days") }
            },
            [
              _vm.interaction
                ? _c(
                    "vs-button",
                    {
                      staticClass: "refreshBtn btn-img",
                      on: { click: _vm.refreshData }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/img/icon_refresh_reload.svg"),
                          alt: "search"
                        }
                      })
                    ]
                  )
                : _vm._e(),
              _vm._v("\n           \n        ")
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("div", { staticClass: "table-content" }, [
      _c("ul", { staticClass: "table-head" }, [
        _c("li", { staticClass: "row" }, [
          _c(
            "ul",
            [
              _c("li", { staticClass: "day-column column" }),
              _vm._l(_vm.hours, function(hour, indexHour) {
                return _c(
                  "li",
                  {
                    key: indexHour,
                    staticClass: "column hour-column",
                    class: { displayed: indexHour % 3 === 0 }
                  },
                  [_c("p", [_vm._v(_vm._s(_vm.$t("dash.hour." + hour)))])]
                )
              })
            ],
            2
          )
        ])
      ]),
      _c(
        "ul",
        { staticClass: "table-body scrollable" },
        _vm._l(_vm.optimalTimes.optimalTimeSlots, function(day, keyDay) {
          return _c("li", { key: keyDay, staticClass: "row" }, [
            _c(
              "ul",
              [
                _c("li", { staticClass: "day-column column" }, [
                  _c("p", [_vm._v(_vm._s(_vm.$t("dash.week." + keyDay)))])
                ]),
                _vm._l(day, function(hour, indexHour) {
                  return _c(
                    "li",
                    {
                      key: indexHour,
                      staticClass: "column",
                      class: {
                        bordered: indexHour % 3 === 0,
                        unbordered: indexHour % 3 === 2
                      },
                      on: {
                        click: function($event) {
                          return _vm.setScheduleDate(keyDay, indexHour)
                        }
                      }
                    },
                    [
                      hour != null
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.filter === "clics",
                                  expression: "filter === 'clics'"
                                }
                              ],
                              staticClass: "hour-wrapper",
                              style: _vm.hourWrapperStyle(hour.rateClicks)
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "hour-checkbox" },
                                [
                                  hour.rateClicks != null
                                    ? _c(
                                        "Tooltip",
                                        {
                                          staticStyle: {
                                            "white-space": "pre-line"
                                          },
                                          attrs: {
                                            text: _vm.getTooltipTextCli(hour)
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticStyle: { margin: "10px" }
                                          }),
                                          _vm._v(
                                            "\n                    \n              "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _vm._e(),
                      [
                        hour != null
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.filter === "impressions",
                                    expression: "filter === 'impressions'"
                                  }
                                ],
                                staticClass: "hour-wrapper",
                                style: _vm.hourWrapperStyle(
                                  hour.rateImpressions
                                )
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "hour-checkbox" },
                                  [
                                    hour.rateImpressions != null
                                      ? _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.getTooltipTextImp(hour)
                                            }
                                          },
                                          [
                                            _c("span", {
                                              staticStyle: { margin: "10px" }
                                            }),
                                            _c("p"),
                                            _vm._v(
                                              "\n                     \n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      hour != null
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.filter === "engagement",
                                  expression: "filter === 'engagement'"
                                }
                              ],
                              staticClass: "hour-wrapper",
                              style: {
                                "background-color":
                                  "rgba(178, 5, 100, " +
                                  hour.rateReachEngagement +
                                  ")"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "hour-checkbox" },
                                [
                                  hour.rateReachEngagement != null
                                    ? _c(
                                        "Tooltip",
                                        {
                                          attrs: {
                                            text: _vm.getTooltipTextEng(hour)
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticStyle: { margin: "10px" }
                                          }),
                                          _c("p"),
                                          _vm._v(
                                            "\n                   \n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "hour-wrapper",
                              style: { "background-color": "rgba(192,192,192)" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "hour-checkbox" },
                                [
                                  _c(
                                    "Tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t("dash.no-activity")
                                      }
                                    },
                                    [
                                      _c("span", {
                                        staticStyle: { margin: "10px" }
                                      }),
                                      _c("p"),
                                      _vm._v(
                                        "\n                   \n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                    ],
                    2
                  )
                })
              ],
              2
            )
          ])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }